
import $ from 'jquery';
import util from 'util/Util';
import constants from 'Constants';
import mobileSyncService from "../../service/mobile/MobileSyncService";
import listService from '../../service/ListService';

class DateUtil {

    updateValueType(model) {
        if (util.isTrue(model.get('showEmpty'))) {
            model.set('dateValueType', 'Empty', { silent: true });
            this.updateMobileModel(model, {key: 'dateValueType', val: 'Empty' });
        } else if (util.isTrue(model.get('showNow'))) {
            model.set('dateValueType', 'Now', { silent: true });
            this.updateMobileModel(model, {key: 'dateValueType', val: 'Now' });
        } else if (model.get('specific')) {
            model.set('dateValueType', 'Specific', { silent: true });
            this.updateMobileModel(model, {key: 'dateValueType', val: 'Specific' });
        }
    }

    updateModel(model) {
        let propVal = model.get('dateValueType');

        if (!propVal) {
            return;
        }

        switch (propVal) {
            case 'Empty':
                // Only clear visible value
                model.set('specificDisplay', '', { silent: true });
                this.updateMobileModel(model, {key: 'specificDisplay', val: '' });
                break;
            case 'Now':
                var date = new Date();
                model.set('specific', this.convertDateToISOString(date), { silent: true });
                this.updateMobileModel(model, {key: 'specific', val: this.convertDateToISOString(new Date()) })

                model.set('specificDisplay', this.getFormattedDate(date, constants.PROP_DEFAULT_DATE_FORMAT), { silent: true });
                this.updateMobileModel(model, {key: 'specificDisplay', val: this.getFormattedDate(date, constants.PROP_DEFAULT_DATE_FORMAT) });
                break;
            case 'Specific':
                // If empty 'specific', put today date
                if (!model.get('specific')) {
                    model.set('specific', this.convertDateToISOString(new Date()), { silent: true });
                    this.updateMobileModel(model, {key: 'specific', val: this.convertDateToISOString(new Date()) } )
                }

                model.set('specificDisplay', this.getFormattedDate(model.get('specific'), constants.PROP_DEFAULT_DATE_FORMAT), { silent: true });
                this.updateMobileModel(model, {key: 'specificDisplay', val: this.getFormattedDate(model.get('specific'), constants.PROP_DEFAULT_DATE_FORMAT) });
                break;
        }

        return model;
    }

    updateMobileModel(model, data) {
        if (listService.mainKind !== constants.KIND_MOBILE) {
            mobileSyncService.synchronizeMobileForm(model, model.get('factoryKey'), data);
        }
    }

    getFormattedDate(date, format) {
        let retDateValue = undefined;
        let d;
        if (date) {
            if(typeof date === 'string' && date.includes(':')) {
                var a = date.split(" ");
                var datePart = a[0].split("-");
                var timePart = a[1].split(":");
                d = new Date(datePart[0], (datePart[1] - 1), datePart[2], timePart[0], timePart[1], timePart[2]);
            }
            else{
                d=new Date(date);
            }
            if (!isNaN(d.getDay())) {
                var month = d.getMonth() + 1;
                var day = d.getDate();

                if (month <= 9) {
                    month = '0' + month;
                }
                if (day <= 9) {
                    day = '0' + day;
                }

                switch (format) {
                    case 'MM/DD/YYYY':
                        retDateValue = month + '/' + day + '/' + d.getFullYear();
                        break;
                    case 'DD/MM/YYYY':
                        retDateValue = day + '/' + month + '/' + d.getFullYear();
                        break;
                    case 'MM.DD.YYYY':
                        retDateValue = month + '.' + day + '.' + d.getFullYear();
                        break;
                    case 'DD.MM.YYYY':
                        retDateValue = day + '.' + month + '.' + d.getFullYear();
                        break;
                    case 'DD-MM-YYYY':
                        retDateValue = day + '-' + month + '-' + d.getFullYear();
                        break;
                    case 'MM-DD-YYYY':
                        retDateValue = month + '-' + day + '-' + d.getFullYear();
                        break;
                    case 'YYYY-MM-DD':
                        retDateValue = d.getFullYear() + '-' + month + '-' + day;
                        break;
                }
            }
        }

        return retDateValue;
    }

    /*
     * Convert from ISO string (YYYY-MM-DD hh:mm:ss) to Date object
     */
    convertISOStringToDate(ISODateString) {
        if (!ISODateString) {
            return null;
        }

        return new Date(ISODateString);
    }

    convertDateToISOString(date) {
        if (!date) {
            return '';
        }

        return this.getFormattedDate(date, 'YYYY-MM-DD') + ' 00:00:00';
    }

}

const dateUtil = new DateUtil();
export default dateUtil;